<template>
  <section class="section-cta">
    <div class="section-cta-rule" aria-hidden="true"></div>

    <div class="section-cta-inner shell">
      <div>
        <p class="eyebrow">
          <span class="eyebrow-line"></span>
          {{ eyebrow }}
        </p>
        <h2 class="display-2">{{ heading }}</h2>
      </div>

      <div class="section-cta-action">
        <p>{{ body }}</p>

        <RouterLink class="btn btn-primary btn-lg" to="/contact">
          Contact Blue Speed
          <ArrowRight />
        </RouterLink>

        <a class="btn btn-ghost btn-lg" :href="whatsappUrl" target="_blank" rel="noopener noreferrer">
          WhatsApp Us
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import { ArrowRight } from "lucide-vue-next";

import { whatsappLink } from "@/config/company";

export default {
  name: "SectionCta",

  components: {
    ArrowRight,
  },

  props: {
    eyebrow: { type: String, default: "Get in touch" },
    heading: { type: String, required: true },
    body: { type: String, required: true },
  },

  data() {
    return {
      whatsappUrl: whatsappLink(),
    };
  },
};
</script>

<style scoped>
.section-cta {
  position: relative;
  z-index: 2;
  overflow: hidden;
  padding: 104px 0;
  border-top: 1px solid rgba(11, 37, 69, 0.07);
  background: #eaf2fb;
}

.section-cta-rule {
  position: absolute;
  top: 0;
  left: 0;
  width: 42%;
  height: 2px;
  background: var(--blue);
}

.section-cta-inner {
  display: grid;
  grid-template-columns: 1.3fr 0.7fr;
  gap: 72px;
  align-items: end;
}

.section-cta-action p {
  margin: 0 0 22px;
  color: var(--muted);
  font-size: 14px;
  line-height: 1.8;
}

.section-cta-action .btn {
  width: 100%;
}

.section-cta-action .btn-ghost {
  margin-top: 10px;
}

@media (max-width: 1080px) {
  .section-cta-inner {
    grid-template-columns: 1fr;
    gap: 36px;
  }

  .section-cta-action {
    max-width: 520px;
  }
}

@media (max-width: 760px) {
  .section-cta {
    padding: 76px 0;
  }
}
</style>
